import { setLocale } from 'yup';
import i18n from 'i18n';

setLocale({
  mixed: {
    required: i18n.t('errors.required'),
  },
  string: {
    max: ({ max }) => i18n.t('errors.maxLength', { count: max }),
  },
});
